/** North American toll-free NPAs, including NANPA's assigned future / reserved codes.
 * Source: https://reports.nanpa.com/public/npa_report.csv (2026-11-04).
 * 800/833/844/855/866/877/888 are in service; 822 and 880-887/889 are future toll-free.
 * This classification does not grant permission, validate assignment or alter emergency handling.
 */
export const NANP_TOLL_FREE_CODES = Object.freeze(['800','822','833','844','855','866','877','880','881','882','883','884','885','886','887','888','889'] as const);
export const TOLL_FREE_BLOCK_CODE = 'pstn_toll_free_blocked' as const;
export const TOLL_FREE_BLOCK_MESSAGE = "Toll-free numbers cannot be called from Sidetone. Use the business's local number instead.";
/** Complete +1 / US national numbers only. Formatting is accepted for UI preflight; canonical API values use the same rule. */
export function isNanpTollFreeDestination(value:string):boolean {
 const compact=value.replace(/[\s().-]/g,'');
 const canonical=/^[0-9]{10}$/.test(compact)?'+1'+compact:/^1[0-9]{10}$/.test(compact)?'+'+compact:compact;
 return /^\+1(?:800|822|833|844|855|866|877|88[0-9])[0-9]{7}$/.test(canonical);
}
